import { getAPI } from "./Networking";
import { SwayyAPIResponse } from "../../../models/NetworkResponse";
import { SwayyCarrier } from "../../../models/SwayyCarrier/SwayyCarrier";

const getErrorMessage = (error: unknown, fallback: string): string => {
  const axiosMessage = (error as any)?.response?.data?.message;
  if (typeof axiosMessage === "string" && axiosMessage.trim()) {
    return axiosMessage;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
};

export default class SwayyCarrierAPI {
  getCarriers = async (): Promise<SwayyCarrier[]> => {
    try {
      const response = (await getAPI("/v1/carriers/admin")) as SwayyAPIResponse<
        SwayyCarrier[] | { data: SwayyCarrier[]; carriers?: SwayyCarrier[] }
      >;

      const payload = response.data ?? response.result;
      if (!response.success || !payload) {
        throw new Error(response.message || "Failed to fetch carriers");
      }

      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload.data)) return payload.data;
      return payload.carriers ?? [];
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to fetch carriers"));
    }
  };
}
